import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "./client";
import { customerDataExportQueryKey, customerQueryKey, customerSubscriptionQueryKey } from "./queryKeys";

function transformCustomer(response) {
  return {
    id: response.id,
    userId: response.user_id,
    email: response.email,
    firstName: response.first_name,
    lastName: response.last_name,
    companyName: response.company_name,
    phoneNumber: response.phone_number,
    createdAt: response.created_at,
    timezone: response.timezone,
    updatedAt: response.updated_at,
    avatarUrl: response.avatar_url,
    addressStreet: response.address_street,
    addressCity: response.address_city,
    addressState: response.address_state,
    addressCountry: response.address_country,
    addressZipCode: response.address_zip,
    name: response.first_name && response.last_name ? `${response.first_name} ${response.last_name}` : response.first_name || response.last_name || "",
  };
}

function transformSubscription(response) {
  return {
    subscriptionId: response.id,
    status: response.status,
    priceId: response.price_id,
  };
}

export function useGetCustomer(options = {}) {
  return useQuery({
    queryKey: customerQueryKey,
    queryFn: () => apiFetch("/extras/api/v2/customers/me"),
    select: transformCustomer,
    ...options,
  });
}

export function useGetSubscription(options = {}) {
  return useQuery({
    queryKey: customerSubscriptionQueryKey,
    queryFn: () => apiFetch("/extras/api/v2/customers/subscription"),
    select: transformSubscription,
    ...options,
  });
}

export function useRetrieveExportedData(options = {}) {
  return useQuery({
    queryKey: customerDataExportQueryKey,
    queryFn: () => apiFetch("/extras/api/v1/customers/download-data"),
    ...options,
  });
}

export function useRequestDataExport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch("/extras/api/v1/customers/download-data", { method: "POST" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: customerDataExportQueryKey });
    },
  });
}
